module.exports = __webpack_public_path__ + "img/age-confirm-bg-chivas.6c06ea9d.png";